import React from "react";
import { useSelector } from "react-redux";
import i18n from "../../../i18n/config";
import { ACTION_DISPLAY_TYPES } from "../../../constants/enums";

// types
import { RootState } from "../../../types/redux";
import type { WalletOperatorDisplay } from "../../../types/sendMoney";

// ui components
import Action from "../../Common/Action";

interface WalletRowProps {
  onEdit?: () => void;
  /** Fixed operator (existing recipient): rendered read-only, no Change/Select. */
  operatorDisplay?: WalletOperatorDisplay;
}

const WalletRow = ({
  onEdit,
  operatorDisplay,
}: WalletRowProps): React.ReactElement => {
  const selectedOperator = useSelector(
    (state: RootState) => state.sendMoney.selectedOperator
  );

  const fixed = !!operatorDisplay;

  const operator: WalletOperatorDisplay | null =
    operatorDisplay ??
    (selectedOperator
      ? { iconUrl: selectedOperator.iconUrl, text: selectedOperator.name }
      : null);

  // icon renders on whichever side of the text the {icon:…} token sat; icon-first by default
  const hasIcon = Boolean(operator?.iconUrl);
  const isIconFirst = operator?.isIconFirst ?? true;
  const showIconFirst = hasIcon && isIconFirst;
  const showIconLast = hasIcon && !isIconFirst;

  return (
    <div>
      <label className="text-primary">{i18n.t("PAGES.SEND_MONEY.TRANSFER_DETAILS.WALLET_SELECTION_LABEL")}</label>
      <div className={`bwp-wallet-select${fixed ? " bwp-wallet-select--fixed" : ""}`}>
        {operator ? (
          <div className="bwp-wallet-select__operator">
            {showIconFirst && (
              <img className="bwp-wallet-select__icon" src={operator.iconUrl} alt="" />
            )}
            <span className={`text-primary${fixed ? " bold" : ""}`}>{operator.text}</span>
            {showIconLast && (
              <img className="bwp-wallet-select__icon" src={operator.iconUrl} alt="" />
            )}
          </div>
        ) : (
          <span className="bwp-wallet-select__placeholder">{i18n.t("COMMON.NOT_SELECTED")}</span>
        )}
        {!fixed && onEdit && (
          <Action
            displayType={ACTION_DISPLAY_TYPES.SECONDARY}
            onClick={onEdit}
            width="auto"
            size="sm"
            title={
              selectedOperator ? i18n.t("COMMON.CHANGE") : i18n.t("COMMON.SELECT")
            }
          />
        )}
      </div>
    </div>
  );
};

export default WalletRow;